import { FC, Fragment } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

import { Paths } from '../../../paths';
import auth from '../../../shared/services/auth/auth.tsx';
import { useSnapshot } from 'valtio';
import store from '../../../rootStore';
import {appStore} from "@store/appStore";

const Header: FC = () => {
    const {  appConfigStore } = store;
    const { ThemeChanger } = appConfigStore;
    useSnapshot(appConfigStore);
    const appconfig = appConfigStore.state;
    // Off the snapshot, not the raw proxy: reading appStore directly registers no
    // valtio dependency, so this only re-rendered when appConfigStore happened to
    // change. loggedInUser never changed mid-session until view-as-user, which is
    // why the header kept showing the target after the session was stopped.
    const { loggedInUser } = useSnapshot(appStore);
    
    const navigate = useNavigate();
    
    const ToggleDark = () => {
        appconfig.dataThemeMode =  appconfig.dataThemeMode == 'dark' ? 'light' : 'dark';
        appconfig.dataHeaderStyles = appconfig.dataHeaderStyles == 'dark' ? 'light' : 'dark';
        appconfig.dataMenuStyles = appconfig.dataNavLayout == 'horizontal' ?  appconfig.dataThemeMode == 'dark' ? 'light' : 'dark' : "dark";
        ThemeChanger(appconfig);
      
        
        if (appconfig.dataThemeMode != 'dark') {
            appconfig.bodyBg1 = "";
            appconfig.bodyBg2 = "";
            appconfig.darkBg = "";
            appconfig.inputBorder = "";
            ThemeChanger(appconfig);
            localStorage.setItem("ynexlighttheme", "light");
            localStorage.removeItem("ynexdarktheme");
            localStorage.removeItem("darkBgRGB1");
            localStorage.removeItem("darkBgRGB2");
            localStorage.removeItem("darkBgRGB3");
            localStorage.removeItem("darkBgRGB4");
        }
        else {
            localStorage.setItem("ynexdarktheme", "dark");
            localStorage.removeItem("ynexlighttheme");
        }
    };
 
    const logOut = () => {
        auth.logOut()
        const path = `${import.meta.env.BASE_URL}${Paths.LOGIN}`;
        navigate(path)
    };

    const changePassword = () => {
        const path = `${import.meta.env.BASE_URL}${Paths.CHANGE_PASSWORD}`;
        navigate(path)
    };

    return (
        <Fragment>
            <header className="app-header">
                <div className="main-header-container container-fluid">

                    <div className="header-content-right ms-auto">
                        <div className="header-element header-theme-mode">
                            <Link to="#" className="header-link layout-setting" onClick={() => ToggleDark()}>
                                <span className="light-layout">
                                    <i className="bx bx-moon header-link-icon"></i>
                                </span>
                                <span className="dark-layout">
                                    <i className="bx bx-sun header-link-icon"></i>
                                </span>
                            </Link>
                        </div>
                        <Dropdown className="header-element header-profile">
                            <Dropdown.Toggle variant='' className="header-link dropdown-toggle" id="mainHeaderProfile" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                                <div className="d-flex align-items-center">
                                <span className="avatar avatar-sm m-2 bg-primary">
                                    {loggedInUser.first_name.substring(0,1)} {loggedInUser.last_name.substring(0,1)}
                                </span>
                                    <div className="d-sm-block d-none">
                                        <p className="fw-semibold mb-0 lh-1">{loggedInUser.first_name} {loggedInUser.last_name}</p>
                                        <span className="op-7 fw-normal d-block fs-11">{loggedInUser.organization.name}</span>
                                    </div>
                                </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu align="end" as="ul" className="main-header-dropdown  pt-0 overflow-hidden header-profile-dropdown" aria-labelledby="mainHeaderProfile">
                                <Dropdown.Item className="d-flex" onClick={changePassword}><i className="ti ti-key fs-18 me-2 op-7"></i>Change Password</Dropdown.Item>
                                <Dropdown.Item className="d-flex" onClick={logOut}><i className="ti ti-logout fs-18 me-2 op-7"></i>Log Out</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </header>
        </Fragment>
    );
};


export default (Header);
